import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-611c0cc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "goods-class" }
const _hoisted_2 = { class: "contents" }
const _hoisted_3 = { class: "heaer-address" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, "首页", -1))
const _hoisted_5 = {
  key: 0,
  class: "contents"
}
const _hoisted_6 = { class: "yellow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_head = _resolveComponent("home-head")!
  const _component_current_address = _resolveComponent("current-address")!
  const _component_goods_class = _resolveComponent("goods-class", true)!
  const _component_goods_list = _resolveComponent("goods-list")!
  const _component_page_show = _resolveComponent("page-show")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_html_footer = _resolveComponent("html-footer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_home_head),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_current_address, null, {
          address: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" > 方案中心 ")
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_goods_class, { onSetGoodsWhere: _ctx.setGoodsWhere }, null, 8, ["onSetGoodsWhere"])
    ]),
    _withDirectives(_createVNode(_component_goods_list, {
      goodslit: _ctx.goodslit.datas.data,
      loading: _ctx.loading
    }, null, 8, ["goodslit", "loading"]), [
      [_directive_loading, _ctx.loading]
    ]),
    (_ctx.goodslit.datas.total > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_page_show, {
            pageSize: _ctx.goodslit.datas.pageSize,
            total: _ctx.goodslit.datas.total,
            ref: "pageShowref",
            onHandleCurrentChange: _ctx.handleCurrentChange
          }, null, 8, ["pageSize", "total", "onHandleCurrentChange"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.goodslit.datas.total < 1)
      ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          "image-size": "400",
          image: "/static/free/icon/goodsEmpty.png",
          description: "当前没有搜索到您要的结果……！",
          class: "empty"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_button, {
                type: "primary",
                round: "",
                onClick: _ctx.gotoHome
              }, {
                default: _withCtx(() => [
                  _createTextVNode("去首页")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_html_footer)
  ]))
}